/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProvenanceList } from '../models/PaginatedProvenanceList';
import type { PatchedProvenance } from '../models/PatchedProvenance';
import type { Provenance } from '../models/Provenance';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LeadsProvenancesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProvenanceList
     * @throws ApiError
     */
    public leadsProvenancesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedProvenanceList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-provenances/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns Provenance
     * @throws ApiError
     */
    public leadsProvenancesCreate({
        requestBody,
    }: {
        requestBody: Provenance,
    }): CancelablePromise<Provenance> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/leads-provenances/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns Provenance
     * @throws ApiError
     */
    public leadsProvenancesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this Provenance.
         */
        id: number,
    }): CancelablePromise<Provenance> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-provenances/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns Provenance
     * @throws ApiError
     */
    public leadsProvenancesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this Provenance.
         */
        id: number,
        requestBody: Provenance,
    }): CancelablePromise<Provenance> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/leads-provenances/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns Provenance
     * @throws ApiError
     */
    public leadsProvenancesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this Provenance.
         */
        id: number,
        requestBody?: PatchedProvenance,
    }): CancelablePromise<Provenance> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/leads-provenances/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public leadsProvenancesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this Provenance.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/leads-provenances/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
